import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="font-heading text-xl font-bold text-white mb-4">{siteInfo.name}</h3>
              <p className="text-sm text-secondary-400 leading-relaxed mb-4">
                {t('site.tagline')}
              </p>
              <div className="flex items-center gap-3">
                <a
                  href={siteInfo.socialMedia.weibo}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer"
                  aria-label="抖音"
                >
                  <i className="ri-tiktok-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">{t('nav.categories')}</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-secondary-400 hover:text-white transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-secondary-400 hover:text-white transition-colors cursor-pointer">
                    {t('nav.home')}
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-secondary-400 hover:text-white transition-colors cursor-pointer">
                    {t('footer.links.about')}
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-secondary-400 hover:text-white transition-colors cursor-pointer">
                    {t('footer.links.privacy')}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-secondary-400 hover:text-white transition-colors cursor-pointer">
                    {t('footer.links.terms')}
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">{t('footer.links.contact')}</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-secondary-400">
                  <i className="ri-mail-line"></i>
                  <span>{siteInfo.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-400">
                  <i className="ri-phone-line"></i>
                  <span>{siteInfo.phone}</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-secondary-400">
                  <i className="ri-map-pin-line mt-0.5"></i>
                  <span>{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-500">
              {t('footer.copyright')}
            </p>
            <p className="text-xs text-secondary-600">
              {t('footer.disclaimer')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}